<template>
  <div v-if="errorAlert">
    {{ notify() }}
  </div>
</template>
<script>
import swal from "sweetalert2";

export default {
  computed: {
    errorAlert() {
      return this.$store.state.registration.error_alert;
    },
  },
  methods: {
    notify() {
      swal.fire({
        type: "error",
        title: "Oops...",
        html:
          "<h5>Something went wrong!</h5><br/>" +
          "<h5>Please refresh the page and try again.</h5><br/>",
        showConfirmButton: true,
      });
    },
  },
};
</script>
